import React, { useContext, useState } from 'react';
import { Step, StepperProvider } from '../../../Contexts/StepperContext';
import ConstructorContactStep from '../../../Components/Stepper/Steps/ConstructorRequest/ConstructorContactStep';
import ConstructorDetailStep from '../../../Components/Stepper/Steps/ConstructorRequest/ConstructorDetailStep';
import Stepper from '../../../Components/Stepper/Stepper';
import { UserDispatchContext } from '../../../Contexts/UserContext';
import { logoutUser } from '../../../Utils/User/Actions';
import {
  extractErrorMessage,
  redirectOnAuthFailure
} from '../../../Utils/Errors/Errors';
import { AlertsDispatchContext } from '../../../Contexts/AlertsContext';
import { ALERT_TYPE } from '../../../Components/Alerts/alert_enums';
import { createConstructorRequestAPI } from '../../../API/Constructors/ConstructorsAPI';
import { ConstructorRequestType } from '../../../Enums/constructors';
import fileToBase64 from '../../../Utils/Transform/FileToBase64';
import { history } from '../../../Routes/history';
import { ROUTE_NAMES } from '../../../Routes/Routes';

const STEPS = [
  { label: 'Información de contacto' },
  { label: 'Detalle de la solicitud' }
];

const AditonalJobForm = ({
  contractId,
  constructorInfo,
  authToken,
  formId,
  setNextButtonText,
  setGoBack,
  setCanSubmit,
  setLoading
}) => {
  const [currentStep, setCurrentStep] = useState(1);

  const setCurrentUser = useContext(UserDispatchContext);
  const setAlert = useContext(AlertsDispatchContext);

  const submitAditionalJobRequest = async formData => {
    const {
      attachments: nonBase64attachments,
      projectConsecutive,
      businessIdentification,
      businessIdentificationType,
      businessName,
      fullName,
      identification,
      identificationType,
      email,
      cellPhoneNumber,
      projectName,
      subject,
      description
    } = formData;

    setCanSubmit(false);
    setLoading(true);

    const attachments = await Promise.all(
      nonBase64attachments
        .filter(Boolean)
        .map(async ({ attachmentType, name, extension, file }) => {
          const content = await fileToBase64(file);
          return {
            name: attachmentType ? `${attachmentType}.${extension}` : name,
            content,
            extension
          };
        })
    );

    const response = await createConstructorRequestAPI(authToken, {
      projectConsecutive,
      contractId,
      requestType: ConstructorRequestType.AditionalJob,
      attachments,
      businessIdentification,
      businessIdentificationType,
      businessName,
      fullName,
      identification,
      identificationType,
      email,
      cellPhoneNumber,
      projectName,
      subject,
      description
    });

    if (!response.success) {
      setCanSubmit(true);
      setLoading(false);
      if (
        redirectOnAuthFailure(response, '/', () => logoutUser(setCurrentUser))
      ) {
        return;
      }

      setAlert({
        type: ALERT_TYPE.ERROR,
        message: extractErrorMessage(response).message
      });
      return;
    }

    setAlert({
      type: ALERT_TYPE.SUCCESS,
      message: 'Solicitud enviada satisfactoriamente',
      onClose: () =>
        history.push(`${ROUTE_NAMES.constructorPhase}/${contractId}`)
    });

    setLoading(false);
    setCanSubmit(true);
  };

  return (
    <>
      <Stepper steps={STEPS} currentStep={currentStep} />
      <StepperProvider onSubmit={submitAditionalJobRequest}>
        <Step>
          <ConstructorContactStep
            constructorInfo={constructorInfo}
            formId={formId}
            setGoBack={setGoBack}
            setCurrentStep={setCurrentStep}
            setNextButtonText={setNextButtonText}
            setCanSubmit={setCanSubmit}
          />
        </Step>
        <Step>
          <ConstructorDetailStep
            withDescription
            requestType={ConstructorRequestType.AditionalJob}
            formId={formId}
            setGoBack={setGoBack}
            setCurrentStep={setCurrentStep}
            setNextButtonText={setNextButtonText}
          />
        </Step>
      </StepperProvider>
    </>
  );
};

export default AditonalJobForm;
